import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchInvoiceRemarks(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axiosIns.get('/invoice_remarks', {params:queryParams})
          .then(response => resolve(response))
          .catch(error => reject(error))
        })
    },
    addInvoiceRemark(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/invoice_remarks', data)
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    deleteInvoiceRemark(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.delete('/invoice_remarks', {params:data})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
